<template>
    <div class="w-full h-full flex flex-col justify-center py-12">
        <div class="relative sm:pt-32 sm:mx-auto sm:w-full sm:max-w-4xl">
            <div class="bg-white py-16 px-4 shadow sm:rounded-lg sm:px-10">
                <img
                    class="mx-auto h-12 w-auto"
                    src="@/assets/logo-full.png"
                    alt="upyield logo"
                >
                <h2 class="mt-6 text-center text-3xl font-bold text-gray-900">
                    Registration completed
                </h2>
                <h2 class="mt-3 text-center text-2xl font-bold text-gray-900">
                    Thank you!
                </h2>
                <p class="mt-6 text-center text-xl text-gray-900">
                    An e-mail has been sent {{ email &&`to` }} <b>{{ email && email }}</b> to be verified.
                </p>
                <p class="mt-2 text-center text-xl text-gray-900">
                    We will process your registration request and get back to you once it is approved.
                </p>
                <a
                    :href="config.value.register ? config.value.register.termsconditions_url : '#not-defined'"
                    class="flex justify-center mt-8"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    <button
                        type="button"
                        class="shadow-sm w-full md:w-1/2 flex justify-center gap-2 px-6 py-4 border border-transparent font-medium rounded-md text-white bg-primary-700
                                    hover:bg-primary-500 focus:outline-none focus:shadow-outline-primary focus:border-primary-700 active:bg-primary-700
                                    transition duration-150 ease-in-out"
                    >
                        <DownloadIcon size="1.5x" /> Accepted T&C
                    </button>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import config from '@/config';
import { DownloadIcon } from '@vue-hero-icons/outline';

export default defineComponent({
    name: 'Login',
    components: { DownloadIcon },

    props: {
        email: {
            type: String,
            default: null,
        },
    },

    setup () {
        return {
            config,
        };
    },
});
</script>

<style lang="scss">
.Login .navigation {
    display: none;
}
</style>
